module.exports = __webpack_public_path__ + "ec7f97ddbfc83e46c16afcc64be35ad0.pdf";